/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudWireIcon24Regular = forwardRef('NetCloudWireIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.25 17.75H6.3A5.7 5.7 0 0 1 4.719 6.618a6.301 6.301 0 0 1 11.925-1.766l.156-.002a6.45 6.45 0 0 1 0 12.9h-4.05v3.5h5.5a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1 0-1.5h5.5v-3.5ZM6.159 7.255a4.8 4.8 0 0 1 9.298-1.36.75.75 0 0 0 .787.486 4.95 4.95 0 1 1 .556 9.87l-4.8-.001H6.358a4.2 4.2 0 0 1-.79-8.307.75.75 0 0 0 .59-.688Z" })));
});
